import { apiFunctionsEnum } from 'constants/api.constants';
import {
	setLoading,
	setPages,
	setSubMenu,
	setError,
	setLanguages,
	setCurrentTab,
	setUploadingFile,
	setCurrentData,
	updateCurrentData,
	setOriginCurrentData,
} from 'state/reducers/content.reducers';
import { errorMessages } from 'constants/ui.constants';
import ApiService from './api.service';
import FormData from 'form-data';
import { IFeature, filedGroupItemDataType } from 'constants/content.constants';
import { permissionEnums } from 'constants/permission.constants';
import { setErrorMessage } from 'utils/index';
import _ from 'lodash';

export function getFeaturesByCategory(category: string) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError(null));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_FEATURES_BY_CATEGORY, { category })
			.then((response: any) => {
				const subMenus = response.data.features.map((feature: IFeature) => {
					return { ...feature, permissions: [permissionEnums.OPEN_PAGES_CONTENT] };
				});
				dispatch(setSubMenu({ items: subMenus, nestedSubmenu: true }));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function getPagesByFeature(category: string, feature: string) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError(null));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_PAGES_BY_FEATURE, { category, feature })
			.then((response: any) => {
				dispatch(setPages(response.data.pages));
				dispatch(setCurrentData(response.data.pages));
				dispatch(setOriginCurrentData(response.data.pages));
				dispatch(setCurrentTab(0));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function getFeatureLanguages() {
	return async (dispatch: any) => {
		dispatch(setError(null));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_LANGUAGES)
			.then((response: any) => {
				dispatch(setLanguages(response.data.languages));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});

				dispatch(setLanguages([]));
			});
	};
}

export function uploadFile(data: any) {
	const { file, itemId } = data;
	return async (dispatch: any) => {
		dispatch(setUploadingFile(true));
		dispatch(setError(null));
		dispatch(setLoading(true));
		const formData = new FormData();
		formData.append('file', file, file.name);
		formData.append('itemId', itemId);
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.SAVE_FILE, formData, { 'Content-Type': 'multipart/form-data' })
			.then((response: any) => {
				dispatch(
					updateCurrentData({
						dataType: filedGroupItemDataType.IMAGE,
						data: { image: response.data.image },
						itemId,
					})
				);
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setUploadingFile(false));
				dispatch(setLoading(false));
			});
	};
}

export function savePage(items: any) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError(null));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.SAVE_TRANSLATIONS, { items })
			.then(() => {
				dispatch(setOriginCurrentData());
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}
export function sendEmailExample(data: any) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError(null));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.SEND_EMAIL_EXAMPLE, data)
			.then(() => {})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}
